// decorators/event.ts
import "../chemistry-lit-element.js";
var event = (protoOrDescriptor, name) => {
  const element = protoOrDescriptor.constructor;
  if (element && name)
    element._eventProperties.add(name);
};
export {
  event
};
